import React from 'react';
import { useNavigate } from 'react-router-dom';
import './Welcome.css';

const Welcome = () => {
  const navigate = useNavigate();

  return (
    <div className="welcome-container">
      <div className="welcome-card">
        <h1>Welcome!</h1>
        <p className="welcome-subtitle">Who are you?</p>
        
        <div className="role-selection">
          <div className="role-card" onClick={() => navigate('/student-login')}>
            <div className="role-icon">🎓</div>
            <h3>Student</h3>
            <p>Access your courses and grades</p>
          </div>
          
          <div className="role-card" onClick={() => navigate('/teacher-login')}>
            <div className="role-icon">👨‍🏫</div>
            <h3>Teacher</h3>
            <p>Manage courses and students</p>
          </div>
          
          <div className="role-card" onClick={() => navigate('/admin-login')}>
            <div className="role-icon">⚙️</div>
            <h3>Admin</h3>
            <p>System administration</p>
          </div>
        </div>
        
        <div className="admin-note">
          <p>⚠️ <strong>Note:</strong> Admin must login first to set up courses and teachers</p>
        </div>
      </div>
    </div>
  );
};

export default Welcome;